import { TableHoverCell } from 'foundations-components/transitional/components/Table';
import { View } from 'foundations-components/components/View';
import { getObjectLabel } from 'customer-data-objects/objects/getObjectLabel';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { AvatarCellWrapper } from '../AvatarCell';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import { alwaysUndefined } from '../../utils/alwaysUndefined';
import { CRM_PROPERTY_DATE_FORMAT, CRM_PROPERTY_DATE_TIME_FORMAT } from '../properties/constants';
import { useLinkProps } from '../getLinkDetails';
import TruncateDiv from '../TruncateDiv';
import EmptyState from '../EmptyState';
import { jsx as _jsx } from "react/jsx-runtime";
const AVATAR_OBJECT_TYPES = [CONTACT_TYPE_ID, COMPANY_TYPE_ID];
const MaybeAvatarWrapper = ({
  value,
  objectTypeId,
  objectId,
  children
}) => {
  if (!AVATAR_OBJECT_TYPES.includes(objectTypeId)) {
    return children;
  }
  return /*#__PURE__*/_jsx(AvatarCellWrapper, {
    objectTypeId: objectTypeId,
    displayName: value,
    id: objectId,
    children: children
  });
};
const NoLinkIfDisabled = props => {
  if (props.disabled) {
    return props.children;
  }
  return /*#__PURE__*/_jsx(Link, Object.assign({}, props));
};
const DisplayValue = ({
  objectTypeId,
  objectId,
  value,
  propertyDefinition,
  getSecondaryPropertyValue
}) => {
  //TODO - should this be in customer-data-objects PropertyIdentifiers?
  const isContactNameProperty = Boolean(propertyDefinition.name === 'name' && objectTypeId === CONTACT_TYPE_ID);

  /* This TruncateDiv makes links the full width of the parent */
  /* important for ATs as selenium will click on the midpoint of the cell, */
  /* and if this doesnt span wide enough it wont click the link */
  return /*#__PURE__*/_jsx(TruncateDiv, {
    children: isContactNameProperty ? /*#__PURE__*/_jsx("span", {
      "data-test-id": `label-cell-unformatted-property-${objectTypeId}-${objectId}-${propertyDefinition.name}`,
      children: value || /*#__PURE__*/_jsx(EmptyState, {})
    }) : /*#__PURE__*/_jsx(FormattedPropertyV2, {
      "data-test-id": `label-cell-formatted-property-${objectTypeId}-${objectId}-${propertyDefinition.name}`,
      objectTypeId: objectTypeId,
      objectId: objectId,
      property: propertyDefinition,
      value: value,
      getDraftValue: getSecondaryPropertyValue,
      getSavedValue: alwaysUndefined,
      dateFormat: CRM_PROPERTY_DATE_FORMAT,
      dateTimeFormat: CRM_PROPERTY_DATE_TIME_FORMAT,
      autoManageHighlySensitiveValue: false,
      enableAutolinking: false
    })
  });
};
const LabelCellPresentational = ({
  requiredCellProps,
  hoverContent,
  objectTypeDefinition,
  object,
  getLinkDetails,
  getSecondaryPropertyValue,
  propertyDefinition
}) => {
  const {
    'data-onboarding': dataOnboarding,
    'data-table-external-id': dataTableExternalId,
    'data-test-id': dataTestId,
    'data-column-index': dataColumnIndex
  } = requiredCellProps;
  const linkProps = useLinkProps({
    getLinkDetails,
    objectTypeId: objectTypeDefinition.objectTypeId,
    objectId: object.objectId
  });

  // HACK: Technically this is a formatted name for contacts, but in all other
  // cases it is actually the value of primaryDisplayLabelPropertyName
  const value = getObjectLabel(objectTypeDefinition, object);
  const content = !propertyDefinition ?
  /*#__PURE__*/
  //propertyDefinition is required here, but this is a sane error fallback
  //CDP does this often - showing the internal value when an error occurs
  _jsx("span", {
    "data-test-id": "LabelCellPresentational-missing-property-definition",
    "data-objectTypeId": objectTypeDefinition.objectTypeId,
    "data-objectId": object.objectId,
    children: value || /*#__PURE__*/_jsx(EmptyState, {})
  }) : /*#__PURE__*/_jsx(View, {
    children: /*#__PURE__*/_jsx(MaybeAvatarWrapper, {
      value: value,
      objectTypeId: objectTypeDefinition.objectTypeId,
      objectId: object.objectId,
      children: /*#__PURE__*/_jsx(NoLinkIfDisabled, Object.assign({}, linkProps, {
        children: /*#__PURE__*/_jsx(DisplayValue, {
          objectTypeId: objectTypeDefinition.objectTypeId,
          objectId: object.objectId,
          propertyDefinition: propertyDefinition,
          value: value,
          getSecondaryPropertyValue: getSecondaryPropertyValue
        })
      }))
    })
  });
  return /*#__PURE__*/_jsx(TableHoverCell, {
    as: 'td',
    "data-column-index": dataColumnIndex,
    "data-onboarding": dataOnboarding,
    "data-table-external-id": dataTableExternalId,
    "data-test-id": dataTestId,
    hoverContent: hoverContent,
    children: content
  });
};
export default LabelCellPresentational;